<template>
  <div
    v-if="shown"
    role="button"
    tabindex="0"
    :aria-label="$t('aiChat.title')"
    class="ai-chat-bubble icon-hover-host"
    @click="openPanel"
    @keydown.enter="openPanel"
  >
    <m-icon
      type="astronaut"
      size="22"
    />
  </div>
</template>

<script setup>
import useAiChatPanel from '@/composables/ai-chat/ai-chat-panel';
import { AI_CHAT } from '@/route-names';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();
const { open, openPanel } = useAiChatPanel();

const shown = computed(() => !open.value
  && route.name !== AI_CHAT
  && !store.state.breakpoint.smAndDown);
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .ai-chat-bubble {
    position: fixed;
    right: 2rem;
    bottom: 2rem;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    color: $font-color-primary;
    cursor: pointer;
    background-color: white;
    border-radius: 50%;
    box-shadow: rgba(15, 15, 15, .05) 0 0 0 1px, rgba(15, 15, 15, .1) 0 3px 6px, rgba(15, 15, 15, .2) 0 9px 24px;
    transition: transform .25s cubic-bezier(.34, 1.56, .64, 1);

    &:hover {
      transform: scale(1.08);
    }
  }
</style>
